<ag-grid-angular
  class="ag-theme-digiwall w-100"
  [rowData]="rows()"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [gridOptions]="gridOptions"
>
</ag-grid-angular>
